module.exports = __webpack_public_path__ + "img/Privacy-Settings.18b388b3.png";